module.exports = __webpack_public_path__ + "d0e193e8633aa76a8e2c5aad49a1c97e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/imgs/Obamaserbe.svg
// module id = 261
// module chunks = 1